<template>
  <div class="mb-3 mt-5">
    <b-container class="mt-5">
      <h1 class="text-primary font-weight-bold text-center mb-5">{{ $t('login.title') }}</h1>
      <login-form></login-form>
    </b-container>
  </div>
</template>

<script>
import LoginForm from '../components/LoginForm'
export default {
  name: 'Login',
  components: { LoginForm }
}
</script>

<style scoped>
  h1 {
    text-transform: uppercase;
  }
</style>
